const tableContainer = document.getElementById('quickOrderContainer');

const selectors = {
  // Table buttons
  quickOrderTable : document.getElementById('quickOrderTable'),
  addTableRowBtn : document.getElementById('quickOrderAdd'),
  basketSubmitBtn : document.getElementById('quickOrderBasket'),
  quickOrderError : document.getElementById('quickOrderError'),
  quickOrderTotal : document.getElementById('quickOrderTotal'),
  productSku : document.getElementById('productSku'),
  // Generic product data selectors
  productId : '[data-product-id]',
  productQuantity : '[data-product-quantity]',
  productSubTotal : '[data-product-subtotal]',
}

initListeners();

function initListeners() {
  // Product SKU submit
  tableContainer.addEventListener('click', (e) => {
    const row = e.target.closest('.quick-order-table__item');

    if (e.target.hasAttribute('data-product-submit')) {
      retrieveProduct(row);
    } else if (e.target.parentElement.classList.contains('qty-input')) { 
      updateQuantity(e.target.parentElement, row);
    }
  })

  // Product option change
  tableContainer.addEventListener('change', (e) => {
    if (e.target.hasAttribute('data-product-options')) {
      const row = e.target.closest('.quick-order-table__item');
      updateVariation(e, row);
    }
  })

  // Add new row
  if (selectors.addTableRowBtn) {
    selectors.addTableRowBtn.addEventListener('click', () => retrieveProduct());
  }

  // Add products to basket
  if (selectors.basketSubmitBtn) {
    selectors.basketSubmitBtn.addEventListener('click', () => submitBasket());
  }
}

function retrieveProduct() {
  const sku = productSku.value.replace(' ', '');

  if (!sku) return;

  fetch(`/search/suggest.json?q=${sku}&resources[type]=product&&resources[options][fields]=variants.sku`)
  .then((response) => response.json())
  .then(data_json => {
    if (data_json.resources.results.products.length == 0) {
      errorNotification('That is not a valid product SKU');
      return;
    }

    const data = data_json.resources.results.products[0];

    fetch(`/products/${data.handle}.json`)
    .then((response) => response.json())
    .then(results => {
      const variant = results.product.variants.filter((variant) => {
        return variant.sku == sku;
      });
      addProduct(results.product.title, variant[0]);
    })
    .catch((error) => {
      console.error('Error fetching product: ' + error);
      errorNotification('There was an unexpected error');
      return;
    });        
  });
}

function addProduct(title, variant) {
  if (quickOrderTable.classList.contains('hidden')) {
    quickOrderTable.classList.remove('hidden');
    quickOrderTable.setAttribute('aria-hidden', false);
  }

  if (document.querySelector('.quick-order-table__checkout').classList.contains('hidden')) {
    document.querySelector('.quick-order-table__checkout').classList.remove('hidden')
    document.querySelector('.quick-order-table__checkout').setAttribute('aria-hidden', false)
  }

  const newRow = document.getElementById('quickOrderBody').insertRow();
  newRow.classList.add('quick-order-table__item');
  newRow.innerHTML = `
    <td>
      <div class="quick-order-table__sku-field">
        <button type="button" class="btn btn--sm btn--remove" onclick="removeProduct(this)" aria-label="Remove product" title="Remove product">
          <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M5 19 19 5M5 5l14 14"/></svg>
        </button>
        ${variant.sku}
      </div>
      <input type="hidden" class="hidden" disabled value="${variant.id}" data-product-id>
    </td>
    <td><p class="quick-order-table__product-title">${title}</p></td>
    <td>
      <p class="quick-order-table__label">Price</p>
      £${variant.price} GBP
    </td>
    <td>
      <p class="quick-order-table__label">Quantity</p>
      <input
        type="number" value="1" min="1"
        class="input" step="1"
        onchange="updateQuantity(this, ${variant.price})"
        data-product-quantity
      >
    </td>
    <td>
      <p class="quick-order-table__label">Sub-Total $ (VAT included)</p>
      <span data-product-subtotal>${variant.price}</span>
    </td>
  `;

  updateTotal();
}

function updateQuantity(input, price) {
  const quantity = input.value;
  const total = quantity * price;
  input.parentNode.nextElementSibling.querySelector('[data-product-subtotal]').innerText = total;
  updateTotal();
}

function updateTotal() {
  let total = 0;
  const subTotals = tableContainer.querySelectorAll('[data-product-subtotal]');

  if (!subTotals) return;
  
  subTotals.forEach(sub => {
    total += parseFloat(sub.innerText);
  });

  quickOrderTotal.innerText = total.toFixed(2);
}

function removeProduct(btn) {
  const row = btn.parentNode.parentNode.parentNode;
  row.parentNode.removeChild(row)
  updateTotal();
}

async function submitBasket() {
  let newFormData = {
    items: []
  };

  document.querySelectorAll('table.quick-order-table tbody tr').forEach((row) => {
    newFormData.items.push({
      'id': row.querySelector(selectors.productId).value,
      'quantity': parseInt(row.querySelector(selectors.productQuantity).value)
    })
  });

  if (!newFormData.items.length > 0) return;
  
  try {
    tableContainer.classList.add('pointer-events-none');

    const newResponse = fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(newFormData)
    })
  } catch (error) {
    console.error('Error fetching product: ' + error);
    errorNotification('There was an unexpected error');
  } finally {
    tableContainer.classList.remove('pointer-events-none');
    
    setTimeout(() => {
      retrieveCartItems();
    }, 1500)
  }
}

function errorNotification(error) {
  selectors.quickOrderError.firstElementChild.textContent = error;
  selectors.quickOrderError.classList.add('active');

  setTimeout(() => {
    selectors.quickOrderError.classList.remove('active');
  }, 5000)
}

/*
  Re-renders the cart drawer, should be used when a product with add ons is added to the basket
*/
async function retrieveCartItems() {
  const sectionSelector = document.querySelector('.cc-cart-drawer.shopify-section');
  const loaders = document.querySelectorAll('.cart-item__loader');

  sectionSelector.classList.add('pointer-events-none');
  
  if (loaders) {
    loaders.forEach((loader) => {
      loader.hidden = false;
    });
  }

  try {
    const response = await fetch('/?section_id=cart-drawer')
    
    if (!response.ok) {
      console.log('Failed to update cart')
    }

    const data = await response.text();
    
    sectionSelector.outerHTML = data;
  } catch (error) {
    console.error('Failed to update cart', error)
  } finally {
    sectionSelector.classList.remove('pointer-events-none');

    if (loaders) {
      loaders.forEach((loader) => {
        loader.hidden = true;
      });
    }

    const drawer = document.querySelector('.drawer.drawer--cart');
    drawer.setAttribute('open', '');
    drawer.setAttribute('aria-hidden', 'false');

    const overlay = document.querySelector('.js-overlay');
    overlay.classList.add('is-visible');

    overlay.addEventListener('click', () => {
      drawer.removeAttribute('open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-visible');
    })
  }
}